import baseRequest from 'queries/baseRequest';
import endpoints from 'consts/endpoints';

export const getAccountsByIdCompany = (companyId: string) =>
  baseRequest({ path: endpoints.getAccountsByIdCompanyUrl(companyId) });
